module.exports = __webpack_public_path__ + "static/img/robot.e24cb0ad.png";